import {
  Box,
  Button,
  CardMedia,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  SelectChangeEvent,
  Theme,
  Typography,
} from '@mui/material';
import MFSelectField from '../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from './components';
import { MFTextField } from '../../lib/formik';
import {
  Formik,
  setNestedObjectValues,
  useFormikContext,
  validateYupSchema,
  yupToFormErrors,
  FormikHelpers,
  FormikProps,
} from "../../lib/formik/Formik";
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useRef, useState } from 'react';
import { Applicant, Bank, FamilyListObj, GetDataForKycModificationResponseBody, GetFamilyListResponseBody, KycDetails, MfuKycModificationResponseBody, MfuKycOnboardingResponseBody } from '../../redux-store/types/api-types';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  applicantStatus,
  applicantStatusMasters,
  APPLICATION_LISTING_STATUS,
  FAMILY_MAPPING_TYPE,
  genderMasters,
  maritalMasters,
  occupationDetailsMasters,
  relatedRelations,
  relationshipsWithGuardian,
  salutationsMasters,
  USER_ROLES,
} from '../../utils/constant';
import {
  getApplicantName,
  getApplicantType,
  getFirstHolderName,
  saveForLater,
  getRelation,
  applyRoleBasedStatus,
  applicationComparison,
  sendApplication_Nri,
  removeSingleQuote,
  getOccupationType,
  preventSpecialCharacters,
  futureAge,
  isMinor,
  isOnboardingTypeMinor,
  getUniqueIdentityText,
  isModuleAllowed,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { FetchData, updateApplication } from '../../redux-store/actions/application';
import { useHistory, useRouteMatch } from 'react-router';
import { ConfirmationDialog, CountryCodesDropDown } from '../commonComponents';
import { personalDetailsSchema } from '../../utils/schema';
import MFCheckbox from '../../lib/formik/Checkbox';
import { Relations } from '../../utils/constant';
import { useSnackbar } from 'notistack';
import LoadingButton from '@mui/lab/LoadingButton';
import { MinorTextDatePicker, TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import { showError } from '../../redux-store/actions/auth';
import application from '../../redux-store/reducers/application';
import { individualPanRegex } from '../../utils/regex';
import { DeleteIconFilled, WarningIcon } from '../../assets/SvgIcons';
import dayjs from '../../utils/dayjs';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { getDataForKycModification, getFamilyList, MfuKycModification } from '../../redux-store/actions/onBoarding';
import UseRadioGroup from '../../lib/formik/Radio';
import KycEditPopup from '../onboarding/KycEditPopup';
import KycInfoPopup from '../onboarding/KycInfoPopup';

const personalDetailsObject: Partial<Applicant> = {
  name: '',
  namePrefix: '',
  fatherOrSpouseName: '',
  maritalStatus: '',
  relationShipWithFirstApplicant: '',
  gender: '',
  occupationDetails: '',
  occupationType: '',
  status: 'Individual',
  minorPan: '',
  minorDOB: null,
  minorName: '',
  minorFatherName: '',
  minorGender: '',
  minorMobile: '',
  minorCountryCode: '+91',
  minorCountryNameAndCode: 'India: +91',
  minorEmail: '',
  minorNamePrefix: 'Mr.',
  minorFirstName: '',
  minorLastName: '',
  firstName: '',
  lastName: '',
  guardianRelationship: '',
};
type updateApplicant = Applicant & {
  jointApplicantRelation: string | null;
  occupationType: string | null;
  guardianRelationshipTypeOther: string | null;
};
export type Values = {
  modeOfHolding: string;
  applicants: Partial<updateApplicant>[];
  banks: Bank[];
  // poaHolderName: string;
  saveType: string;
  nationalityDropdown: string[];
  familyMappingType: string;
  familyId: string;
  familyName: string;
  isHeadOfFamily: boolean;
  isIndependent: boolean;
};

const familyMappingOptions = [
  { label: "Choose existing family", value: FAMILY_MAPPING_TYPE.EXISTING },
  { label: "Add new family", value: FAMILY_MAPPING_TYPE.NEW }
]

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [personalDetailsObject],
  // poaHolderName: '',
  saveType: 'save and proceed',
  banks: [],
  nationalityDropdown: [],
  familyMappingType: FAMILY_MAPPING_TYPE.EXISTING,
  familyId: "",
  familyName: "",
  isHeadOfFamily: false,
  isIndependent: false
};

const PersonalDetails = ({
  index,
  values,
  applicationStatus,
  dataFetchedFromKRA,
  setValues,
  onboardingType,
}: {
  index: number;
  values: Values;
  applicationStatus?: string;
  dataFetchedFromKRA: boolean | null;
  setValues: FormikHelpers<Values>['setValues'];
  onboardingType: string;
}): JSX.Element => {
  const { path: currentPath } = useRouteMatch();
  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")
  const { setFieldValue } = useFormikContext();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo);
  const isFieldDisabled = isDiyInvestorOnboarding ? false : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role);

  const isNRI = `${values?.applicants?.[index]?.applicantStatus ?? ""}`.toLowerCase() === 'nri';
  const applicantStatusOptions = Object.keys(applicantStatus)
    .filter((status) => (isNRI ? status !== 'Individual' : status === 'Individual'))
    .map((status) => ({
      key: applicantStatus[status],
      value: status,
    }));

  const [open, setOpen] = useState<{
    index: number;
    status: string;
  } | null>(null);

  const handleOpen = (index: number, status: string) => {
    setOpen({ index, status });
  };
  const handleClose = () => {
    setOpen(null);
  };
  return (
    <>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.name`}
          label="Full Name*"
          placeholder="Enter Full Name"
          startAdornment={
            <InputAdornment
              position="start"
              sx={{
                pr: '0 !important',
                mx: '0 !important',
                borderRight: '0 !important',
              }}>
              <MFSelectField
                name={`applicants.${index}.namePrefix`}
                items={salutationsMasters.map((salutation) => ({
                  key: salutation,
                  value: salutation,
                }))}
                // disabled={isFieldDisabled}
                disabled
                // sx={{
                //   '& .MuiOutlinedInput-notchedOutline': {
                //     border: "0 !important",
                //     padding: "0px"
                //   },
                //   color: 'primary.main',
                //   '.MuiSvgIcon-root ': { color: 'primary.main' },
                //   '&.MuiInputBase-root': {
                //     '.MuiSelect-select': {
                //       p: 0,
                //       pr: 2.5,
                //       border: 0,
                //     },
                //   },
                //   '&,&:hover,&.Mui-focused': { '.MuiOutlinedInput-notchedOutline': { border: 0 } },
                // }}
                sx={(theme: Theme) => ({
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: "0 !important"
                  },
                  "& .MuiSelect-select": {
                    padding: "0px 32px 0px 0px !important",
                    borderRadius: "0px !important",
                    borderRightWidth: "1.3px",
                    borderRightStyle: "solid",
                    borderRightColor: theme.palette.text.secondary
                  },
                  '&.Mui-focused': {
                    border: `2px solid ${theme.palette.primary.main}`,
                  },
                })}
              />
            </InputAdornment>
          }
          // disabled={isFieldDisabled || dataFetchedFromKRA || false}
          disabled
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.fatherOrSpouseName`}
          label="Father/Spouse’s Name*"
          placeholder="Enter Father/Spouse Name"
          disabled={isFieldDisabled || dataFetchedFromKRA || false}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.firstName`}
          label="First Name*"
          placeholder="Enter First Name"
          disabled
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.lastName`}
          label="Last Name"
          placeholder="Enter Last Name"
          disabled
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.panNo`}
          label={`${getUniqueIdentityText(company)?.panNumber}*`}
          placeholder={`Enter ${getUniqueIdentityText(company)?.panNo} `}
          disabled={isFieldDisabled || dataFetchedFromKRA || true}
          value={values?.applicants?.[index]?.panNo ?? ""}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <TextDatePicker
          name={`applicants.${index}.dateOfBirth`}
          label="Date Of Birth*"
          disabled
          value={values?.applicants?.[index]?.dateOfBirth ?? ""}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.maritalStatus`}
          label="Marital Status*"
          items={maritalMasters
            .filter((status) => {
              if (values.applicants[index].namePrefix === 'Mr.' && status === 'Widower') return;
              return status;
            })
            .map((status) => ({ key: status, value: status }))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.gender`}
          label="Gender*"
          items={genderMasters.map((gender) => ({ key: gender, value: gender }))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.occupationType`}
          label="Occupation Type*"
          items={occupationDetailsMasters.map((occupation) => ({
            key: occupation,
            value: occupation,
          }))}
          onChange={(e) => {
            setValues({
              ...values,
              applicants: values.applicants.map((_applicant, _index) => {
                if (_index === index) {
                  return {
                    ..._applicant,
                    occupationType: e.target.value,
                    occupationDetails: '',
                  };
                }
                return _applicant;
              }) as Partial<updateApplicant>[],
            });
          }}
        />
      </Grid>
      {values.applicants.map((applicant, idx: number) => {
        if (applicant.occupationType === 'Others' && idx === index) {
          return (
            <Grid item xs={12} lg={6} key={idx}>
              <MFTextField
                name={`applicants.${index}.occupationDetails`}
                label="Please Specify Occupation status*"
                placeholder={`Enter Occupation Type`}
                onChange={(e) => {
                  const occupationDetails = e.target.value.replace(/\s+/g, ' ');
                  setValues({
                    ...values,
                    applicants: values.applicants.map((_applicant, _index) => {
                      if (_index === index) {
                        return {
                          ..._applicant,
                          occupationDetails: occupationDetails,
                        };
                      }
                      return _applicant;
                    }) as Partial<updateApplicant>[],
                  });
                }}
              />
            </Grid>
          );
        }
      })}
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.status`}
          label="Status*"
          // items={Object.keys(applicantStatus).map((status) => ({
          //   key: applicantStatus[status],
          //   value: status,
          // }))}
          items={applicantStatusOptions}
          disabled={isFieldDisabled || isOnboardingTypeMinor(onboardingType)}
          onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
            // if (applicantStatusMasters[value as string] === applicantStatusMasters.NRI) {
            if (
              (applicantStatus[value as string] === applicantStatus.NRE) ||
              (applicantStatus[value as string] === applicantStatus.NRO)
            ) {
              if (
                APPLICATION_LISTING_STATUS[applicationStatus || ''] ===
                APPLICATION_LISTING_STATUS.sent_to_applicant1
              ) {
                handleOpen(index, value as string);
              } else {
                setFieldValue(`applicants.${index}.status`, value);
                setFieldValue(`applicants.${index}.nationality`, 'INDIAN');
              }
            } else {
              if (
                // !values.applicants
                //   .map((applicant, ind) => {
                //     if (ind === index) {
                //       return value;
                //     }
                //     return applicant.status;
                //   })
                //   .includes('NRI') &&
                // APPLICATION_LISTING_STATUS[applicationStatus || ''] ===
                // APPLICATION_LISTING_STATUS.sent_to_amc_approver
                (
                  !values.applicants
                    .map((applicant, ind) => {
                      if (ind === index) {
                        return value;
                      }
                      return applicant.status;
                    })
                    .includes('NRE') &&
                  APPLICATION_LISTING_STATUS[applicationStatus || ''] ===
                  APPLICATION_LISTING_STATUS.sent_to_amc_approver
                ) ||
                (
                  !values.applicants
                    .map((applicant, ind) => {
                      if (ind === index) {
                        return value;
                      }
                      return applicant.status;
                    })
                    .includes('NRO') &&
                  APPLICATION_LISTING_STATUS[applicationStatus || ''] ===
                  APPLICATION_LISTING_STATUS.sent_to_amc_approver
                )
              ) {
                return handleOpen(index, value as string);
              }

              setFieldValue(`applicants.${index}.status`, value);
            }
          }}
        />
      </Grid>
      {index !== 0 && (
        <Grid item xs={12} lg={6}>
          <MFSelectField
            name={`applicants.${index}.jointApplicantRelation`}
            label="Relationship With First Applicant*"
            items={Relations.filter((relation) => {
              const { applicants } = values;
              const selectedRelations = applicants
                .filter(
                  (_applicant, ind) =>
                    ind !== index &&
                    _applicant.jointApplicantRelation &&
                    ['Mother', 'Father', 'Spouse'].includes(_applicant.jointApplicantRelation)
                )
                .map((applicant) => applicant.jointApplicantRelation);
              return !selectedRelations.includes(relation);
            }).map((relation) => ({
              key: relation,
              value: relation,
            }))}
          />
          {/* {values.applicants.map((applicant, idx: number) => {
            if (applicant.jointApplicantRelation === 'Others' && idx === index) {
              return (
                <Grid item xs={12} lg={6} key={idx}>
                  <MFTextField
                    name={`applicants.${index}.relationShipWithFirstApplicant`}
                    label="Please Specify Relationship *"
                    placeholder={`Enter Relationship`}
                  />
                </Grid>
              );
            }
          })} */}
        </Grid>
      )}
      {index !== 0 && (
        values.applicants.map((applicant, idx: number) => {
          if (applicant.jointApplicantRelation === 'Others' && idx === index) {
            return (
              <Grid item xs={12} lg={6} key={idx}>
                <MFTextField
                  name={`applicants.${index}.relationShipWithFirstApplicant`}
                  label="Please Specify Relationship *"
                  placeholder={`Enter Relationship`}
                />
              </Grid>
            );
          }
        })
      )}
      <ConfirmationDialog
        message={`Any change in the investor status will affect the application's status and workflow. Are you sure you want to proceed?`}
        open={open !== null}
        setOpen={handleClose}
        onSave={() => {
          setFieldValue(`applicants.${open?.index}.status`, open?.status);
          setFieldValue(`applicants.${open?.index}.nationality`, 'INDIAN');
          handleClose();
        }}
        onCancel={handleClose}
      />
      {/* <InfoDialog onClose={handleClose} open={open} content={'status changed to draft.'} /> */}
    </>
  );
};
const MinorPersonalDetails = ({
  index,
  values,
  fetchMinorData,
  minorDataFetched,
  setMinorDataFetched,
  setFieldValue,
  previousPan,
  previousDob,
  guardianPan,
  isBSEEnabled
}: {
  index: number;
  values: Values;
  fetchMinorData: any;
  minorDataFetched: string;
  setMinorDataFetched: any;
  setFieldValue: any;
  previousPan: string;
  previousDob: any;
  guardianPan: string | undefined;
  isBSEEnabled: boolean | undefined;
}): JSX.Element => {
  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)

  useEffect(() => {
    const mobileElement = document.getElementsByName('mobile');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);
  return (
    <>
      <Grid item xs={12} lg={6}>
        <MFTextField
          label={`${getUniqueIdentityText(company)?.panNumber}`}
          name={`applicants.${index}.minorPan`}
          placeholder={`Enter ${getUniqueIdentityText(company)?.pan}`}
          autoComplete="off"
          inputProps={{ style: { textTransform: 'uppercase' } }}
          onChange={(e) => {
            setFieldValue(
              `applicants.${index}.minorPan`,
              removeSingleQuote(e.target.value.toUpperCase())
            );
            if (e.target.value.toUpperCase() !== previousPan?.toUpperCase()) {
              setMinorDataFetched('changed');
            } else {
              setMinorDataFetched('fetched');
            }
          }}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MinorTextDatePicker
          label="Date of Birth*"
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'DD/MM/YYYY'}
          name={`applicants.${index}.minorDOB`}
          minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))}
          previousDob={previousDob}
          setMinorDataFetched={setMinorDataFetched}
        />
      </Grid>
      {values.applicants.map((applicant, idx: number) => {
        if (applicant?.minorPan?.length === 10 && idx === index && applicant?.minorDOB) {
          return (
            <Grid item xs={12} key={idx}>
              <Box sx={{ maxWidth: 250, mt: -1 }}>
                <LoadingButton
                  loadingPosition="end"
                  loading={minorDataFetched === 'fetching' ? true : false}
                  disabled={
                    applicant?.minorPan?.length === 10 &&
                      applicant?.minorDOB &&
                      minorDataFetched === 'changed'
                      ? false
                      : true
                  }
                  variant="contained"
                  sx={{ fontWeight: 500, fontSize: 14, width: '100%' }}
                  onClick={() =>
                    fetchMinorData(applicant.minorPan, applicant.minorDOB, values, guardianPan)
                  }>
                  Fetch Data
                </LoadingButton>
              </Box>
            </Grid>
          );
        }
      })}
      {/* <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.minorName`}
          label="Full Name *"
          placeholder="Enter Full Name"
          startAdornment={
            <InputAdornment
              position="start"
              sx={{
                pr: '0 !important',
                mx: '0 !important',
                borderRight: '0 !important',
              }}>
        <MFSelectField
          name={`applicants.${index}.minorNamePrefix`}
          items={salutationsMasters.map((salutation) => ({
            key: salutation,
            value: salutation,
          }))}
          sx={{
            color: 'primary.main',
            '.MuiSvgIcon-root ': { color: 'primary.main' },
            '&.MuiInputBase-root': {
              '.MuiSelect-select': {
                p: 0,
                pr: 2.5,
                border: 0,
              },
            },
            '&,&:hover,&.Mui-focused': { '.MuiOutlinedInput-notchedOutline': { border: 0 } },
          }}
        />
        </InputAdornment>
          }
        />
      </Grid> */}
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.minorFirstName`}
          label="First Name*"
          placeholder="Enter First Name"
          startAdornment={
            <InputAdornment
              position="start"
              sx={{
                pr: '0 !important',
                mx: '0 !important',
                borderRight: '0 !important',
              }}>
              <MFSelectField
                name={`applicants.${index}.minorNamePrefix`}
                items={salutationsMasters.map((salutation) => ({
                  key: salutation,
                  value: salutation,
                }))}
                // sx={{
                //   color: 'primary.main',
                //   '.MuiSvgIcon-root ': { color: 'primary.main' },
                //   '&.MuiInputBase-root': {
                //     '.MuiSelect-select': {
                //       p: 0,
                //       pr: 2.5,
                //       border: 0,
                //     },
                //   },
                //   '&,&:hover,&.Mui-focused': { '.MuiOutlinedInput-notchedOutline': { border: 0 } },
                // }}
                sx={(theme: Theme) => ({
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: "0 !important"
                  },
                  "& .MuiSelect-select": {
                    padding: "0px 32px 0px 0px !important",
                    borderRadius: "0px !important",
                    borderRightWidth: "1.3px",
                    borderRightStyle: "solid",
                    borderRightColor: theme.palette.text.secondary
                  },
                  '&.Mui-focused': {
                    border: `2px solid ${theme.palette.primary.main}`,
                  },
                })}
              />
            </InputAdornment>
          }
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.minorLastName`}
          label="Last Name"
          placeholder="Enter Last Name"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.minorFatherName`}
          label="Fathers Name*"
          placeholder="Enter Father Name"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.minorGender`}
          label="Gender*"
          items={genderMasters.map((gender) => ({ key: gender, value: gender }))}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.minorEmail`}
          label="Email"
          placeholder="Enter Email"
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          label="Mobile Number"
          name={`applicants.${index}.minorMobile`}
          placeholder="Enter Mobile number"
          onKeyDown={(e) => {
            preventSpecialCharacters(e);
          }}
          startAdornment={
            <CountryCodesDropDown
              ElementWidth={mobileElementWidth && mobileElementWidth}
              name={`applicants.${index}.minorCountryNameAndCode`}
              value={values?.applicants[index]?.minorCountryNameAndCode || 'India: +91'}
            />
          }
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.guardianRelationship`}
          label="Relationship with Guardian*"
          // items={relatedRelations.map((relation) => ({
          //   key: relation,
          //   value: relation,
          // }))}
          items={relationshipsWithGuardian.map((relation) => ({
            key: relation,
            value: relation,
          }))}
        />
      </Grid>
      {values?.applicants[index]?.guardianRelationship === 'OTHERS' && (
        <Grid item xs={12} lg={6}>
          <MFTextField
            name={`applicants.${index}.guardianRelationshipTypeOther`}
            label={`Please Specify Relationship *`}
            placeholder={`Enter Please Specify Relationship`}
            inputProps={{ style: { textTransform: 'uppercase' } }}
          />
        </Grid>
      )}
    </>
  );
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo);
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [personalDetailsValues, setPersonalDetailsValues] = useState(initialValues);
  const [minorDataFetched, setMinorDataFetched] = useState('');
  const [previousPan, setPreviousPan] = useState('');
  const [previousDob, setPreviousDob] = useState<any>(null);
  const [applicantToDelete, setApplicantToDelete] = useState<{
    index: number;
  } | null>(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleClose = () => setOpen(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { enqueueSnackbar } = useSnackbar();
  const [errorOnFetch, setErrorOnFetch] = useState(false);
  const [checkJointHolder, setCheckJointHolder] = useState(false);
  const [familyListData, setFamilyListData] = useState<
    Array<{
      key: string;
      value: string;
    }>
  >([])
  const [isFamilyListDataLoading, setFamilyListDataLoading] = useState<boolean>(false)
  const [isEditKycLoading, setEditKycLoading] = useState<boolean>(false)
  const [kycData, setKycData] = useState<KycDetails & {
    isNameChecked: boolean;
    isEmailChecked: boolean;
    isMobileChecked: boolean;
    isAddressChecked: boolean;
  } | null>(null)
  const [selectedApplicantId, setSelectedApplicantId] = useState<number | null>(null)
  const [isKycEditPopupOpen, setKycEditPopupOpen] = useState<boolean>(false)
  const [kycLinkLoading, setKycLinkLoading] = useState<boolean>(false)
  const [kycLinkData, setKycLinkData] = useState<MfuKycOnboardingResponseBody | null>(null)
  const [kycLinkPopupOpen, setKycLinkPopupOpen] = useState<boolean>(false)
  const [mismatchedApplicantData, setMismatchedApplicantData] = useState<{
    index: number;
    applicantData: Partial<Applicant>
  } | null>(null)
  const [mandatoryKycPopupOpen, setMandatoryKycPopupOpen] = useState<boolean>(false)
  const [isMandatoryKycModificationLoading, setMandatoryKycModificationLoading] = useState<boolean>(false)
  const [mandatoryKycModificationRes, setMandatoryKycModificationRes] = useState<MfuKycModificationResponseBody | null>(null)
  const [mandatoryKycModificationLinkPopupOpen, setMandatoryKycModificationLinkPopupOpen] = useState<boolean>(false)
  const [isApplicantDeleteLoading, setApplicantDeleteLoading] = useState<boolean>(false)

  const formikRef = useRef<FormikProps<Values>>(null);
  const hasMandatoryKycPopupShownRef = useRef<boolean>(false);

  const { path: currentPath } = useRouteMatch();

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")

  const fetchFamilyListData = async () => {
    try {
      setFamilyListDataLoading(true)

      const response = await (dispatch(getFamilyList()) as unknown as Promise<GetFamilyListResponseBody>)

      if (!response?.isSuccess) {
        dispatch(showError(response?.message || "No Data available"))
        return
      }

      if (response?.isSuccess) {
        const modifiedFamilyListData = (response?.familyList ?? []).map((obj: FamilyListObj) => ({
          key: obj?.familyName ?? "",
          value: obj?.familyId ?? ""
        }))

        setFamilyListData(modifiedFamilyListData)
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setFamilyListDataLoading(false)
    }
  }

  useEffect(() => {
    fetchFamilyListData()
  }, [])

  useEffect(() => {
    (async function () {
      try {
        const { applicants = [], modeOfHolding = '', banks = [], familyId = "", familyName = "", isHeadOfFamily = "", isIndependent = "" } = application || {};
        const sortedApplicants = applicants
          .map((applicant) => ({
            ...applicant,
            applicant_type: getApplicantType(applicant.applicant_type),
          }))
          .sort((applicant1, applicant2) => {
            return Number(applicant1.applicant_type) - Number(applicant2.applicant_type);
          });
        setPreviousPan(applicants[0]?.minorPan || '');
        setPreviousDob(applicants[0]?.minorDOB || null);
        setPersonalDetailsValues({
          ...personalDetailsValues,
          banks,
          modeOfHolding:
            modeOfHolding === 'joint'
              ? 'joint'
              : sortedApplicants.length > 1
                ? 'either or survivor'
                : modeOfHolding,
          familyId: familyId ?? "",
          familyName: familyName ?? "",
          isHeadOfFamily: isHeadOfFamily === "Y",
          isIndependent: isIndependent === "1",
          // For first time creation familyMappingType = existing as familyId and familyName are not there
          // For edit =>
          // 1. if new selected during creation => familyId will not be there, familyName will be there, so new
          // 2. if existing selected during creation => familyId will be there, so existing
          familyMappingType: familyId ? FAMILY_MAPPING_TYPE.EXISTING : (familyName ? FAMILY_MAPPING_TYPE.NEW : FAMILY_MAPPING_TYPE.EXISTING),
          applicants: applicants.length
            ? sortedApplicants.map((applicant) => {

              const isNRI = `${applicant?.applicantStatus ?? ""}`.toLowerCase() === 'nri';

              return ({
                ...applicant,
                namePrefix:
                  applicant.namePrefix && salutationsMasters.includes(applicant.namePrefix || '')
                    ? applicant.namePrefix
                    : 'Mr.',
                jointApplicantRelation: getRelation(applicant.relationShipWithFirstApplicant)
                  ? applicant.relationShipWithFirstApplicant
                  : 'Others',
                relationShipWithFirstApplicant: getRelation(
                  applicant.relationShipWithFirstApplicant
                )
                  ? ''
                  : applicant.relationShipWithFirstApplicant,
                occupationType: getOccupationType(applicant.occupationDetails)
                  ? applicant.occupationDetails
                  : 'Others',
                occupationDetails:
                  applicant.occupationDetails === 'Others'
                    ? ''
                    : getOccupationType(applicant.occupationDetails)
                      ? ''
                      : applicant.occupationDetails,
                // status: applicant.status || 'Individual',
                status: (isNRI && `${applicant?.status ?? ""}`.toLowerCase() === "individual") ?
                  "NRE" : applicant?.status ?
                    applicant?.status : 'Individual',
                maritalStatus: applicant.maritalStatus || '',
                minorPan: applicant.minorPan || '',
                minorDOB: applicant.minorDOB || null,
                minorName: applicant.minorName || '',
                minorFirstName: applicant.minorFirstName || '',
                minorLastName: applicant.minorLastName || '',
                guardianRelationship:
                  // (relatedRelations.includes(applicant.guardianRelationship as string)
                  //     ? applicant.guardianRelationship
                  //     : applicant.guardianRelationship
                  //       ? 'OTHERS'
                  //       : applicant.guardianRelationship) || '',
                  (relationshipsWithGuardian.includes(applicant.guardianRelationship as string)
                    ? applicant.guardianRelationship
                    : applicant.guardianRelationship
                      ? 'OTHERS'
                      : applicant.guardianRelationship) || '',
                guardianRelationshipTypeOther:
                  // (relatedRelations.includes(applicant.guardianRelationship as string)
                  //     ? ''
                  //     : applicant.guardianRelationship) || '',
                  (relationshipsWithGuardian.includes(applicant.guardianRelationship as string)
                    ? ''
                    : applicant.guardianRelationship) || '',
                minorFatherName: applicant.minorFatherName || '',
                minorGender: applicant.minorGender || '',
                minorMobile: applicant.minorMobile || '',
                minorCountryNameAndCode: applicant.minorCountryNameAndCode || 'India: +91',
                minorEmail: applicant.minorEmail || '',
                minorNamePrefix: applicant.minorNamePrefix || 'Mr.',
                minorCountryCode: applicant.minorCountryCode || '+91',
              })
            })
            : [personalDetailsObject],
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  useEffect(() => {
    let isMounted = true;

    if (hasMandatoryKycPopupShownRef.current) return;

    if (!isFamilyListDataLoading && application && (application?.applicants ?? []).length) {
      if (!isMounted) return;

      const isDigitalOnboarding = `${application?.onboardingVia ?? ""}`.toLowerCase() === "digital"

      for (let applicantIndex = 0; applicantIndex < ((application?.applicants ?? []).length); applicantIndex++) {
        if (
          applicantIndex !== 0 &&
          isDigitalOnboarding &&
          !application?.applicants?.[applicantIndex]?.isKraContactDetailsMatched
          // (
          //   !application?.applicants?.[applicantIndex]?.mobile ||
          //   !application?.applicants?.[applicantIndex]?.email ||
          //   !application?.applicants?.[applicantIndex]?.kraMobileNumber ||
          //   !application?.applicants?.[applicantIndex]?.kraEmailId ||
          //   application?.applicants?.[applicantIndex]?.mobile !== application?.applicants?.[applicantIndex]?.kraMobileNumber ||
          //   `${application?.applicants?.[applicantIndex]?.email ?? ""}`.toLowerCase() !== `${application?.applicants?.[applicantIndex]?.kraEmailId ?? ""}`.toLowerCase()
          // )
        ) {
          hasMandatoryKycPopupShownRef.current = true;

          setMismatchedApplicantData({
            index: applicantIndex,
            applicantData: application?.applicants?.[applicantIndex] ?? {}
          })
          setMandatoryKycPopupOpen(true)

          return
        }
      }
    }
    return () => {
      isMounted = false;
    };
  }, [isFamilyListDataLoading, application]);

  // const validate = (values: Values): FormikErrors<Values> => {
  //   let errors: FormikErrors<Values> = {};
  //   const { applicants, poaHolderName } = values;
  //   if (applicants.length > 1 && !poaHolderName) {
  //     errors = { ...errors, poaHolderName: 'Please select POA' };
  //   }
  //   return errors;
  // };

  const handleApplicant = async (values: Omit<Values, "familyMappingType">, flag = false) => {
    if (minorDataFetched === 'changed' && values?.applicants?.[0]?.minorPan?.length === 10 && values?.applicants?.[0]?.minorDOB) {
      dispatch(showError('Please fetch minor data before proceeding.'));
      return;
    }
    const { applicants = [], modeOfHolding = '', saveType, banks = [], familyId = "", familyName = "", isHeadOfFamily = "", isIndependent = "" } = values;
    const {
      id,
      currentStep,
      hasPOA,
      status,
      applicant1ReferenceId = '',
      applicationNumber,
    } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;
    const updatedBanks =
      applicants[0].name?.split("'").join('').trim() ===
        application?.applicants[0].name?.split("'").join('').trim()
        ? banks
        : banks.map((bank) => ({
          ...bank,
          pennydropCheck: false,
          pennydropVerified: false,
        }));
    const updatedApplicants = values.applicants.map((applicant) => {
      const {
        jointApplicantRelation,
        occupationType,
        guardianRelationship,
        guardianRelationshipTypeOther,
        ...rest
      } = applicant;
      return {
        ...rest,
        // status,
        // addresses: addresses.length
        //   ? addresses.map((address) => {
        //       if (
        //         address.address_type === 'overseas' &&
        //         nationality.toLowerCase() === 'indian' &&
        //         applicantStatusMasters[status as string] === applicantStatusMasters.Individual
        //       ) {
        //         return { ...address, isActive: false };
        //       }
        //       return address;
        //     })
        //   : [],
        name: removeSingleQuote(applicant.name),
        fatherOrSpouseName: removeSingleQuote(applicant.fatherOrSpouseName),
        motherName: removeSingleQuote(applicant.motherName),
        relationShipWithFirstApplicant: getRelation(jointApplicantRelation)
          ? jointApplicantRelation
          : removeSingleQuote(applicant.relationShipWithFirstApplicant),
        occupationDetails: getOccupationType(applicant.occupationDetails)
          ? occupationType
          : removeSingleQuote(applicant.occupationDetails),
        minorPan: removeSingleQuote(applicant.minorPan),
        minorName: removeSingleQuote(applicant.minorName),
        minorFatherName: removeSingleQuote(applicant.minorFatherName),
        minorDOB: applicant?.minorDOB ? dayjs(applicant?.minorDOB).format('YYYY-MM-DD') : "",
        guardianRelationship:
          applicant.guardianRelationship === 'OTHERS'
            ? applicant.guardianRelationshipTypeOther
            : applicant.guardianRelationship,
      };
    });
    const updatedModeOfHolding =
      applicants.filter((applicant) => applicant.isActive).length === 1 ? 'single' : modeOfHolding;
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants?.sort(
          (applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)
        ),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks: updatedBanks,
        applicants: updatedApplicants?.sort(
          (applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)
        ),
        modeOfHolding: updatedModeOfHolding,
        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
        familyId: familyId ?? "",
        familyName: familyName ?? "",
        isHeadOfFamily: isHeadOfFamily ? "Y" : "N",
        isIndependent: isIndependent ? "1" : "0",
      }
    );

    let currentStatus = status

    if (
      !isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
      status === 'sent_to_amc_approver'
    ) {
      currentStatus = 'draft'
    } else if (
      !hasPOA &&
      AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
      status !== 'draft' &&
      applyRoleBasedStatus(role)
    ) {
      currentStatus = 'sent_to_amc_approver'
    } else if (
      (sendApplication_Nri({ ...application!, applicants: updatedApplicants }) &&
        APPLICATION_LISTING_STATUS[status as string] ===
        APPLICATION_LISTING_STATUS.sent_to_applicant1) ||
      (!sendApplication_Nri({ ...application!, applicants: updatedApplicants }) &&
        APPLICATION_LISTING_STATUS[status as string] ===
        APPLICATION_LISTING_STATUS.sent_to_amc_approver)
    ) {
      currentStatus = 'draft'
    }

    if (id && !checkApplication) {
      const response = await dispatch(
        updateApplication({
          body: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ...application!,
            banks: updatedBanks,
            applicants: updatedApplicants,
            modeOfHolding: updatedModeOfHolding,
            ...(saveType === 'save and proceed' && {
              status: currentStatus
            }),
            currentStep: 2,
            // !!currentStep && currentStep > 1
            //   ? applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //     isAllBanksPennyChecked
            //     ? 2
            //     : currentStep
            //   : applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //     isAllBanksPennyChecked
            //   ? 2
            //   : Number(currentStep) + 1,
            familyId: familyId ?? "",
            familyName: familyName ?? "",
            isHeadOfFamily: isHeadOfFamily ? "Y" : "N",
            isIndependent: isIndependent ? "1" : "0"
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
        })
      );

      if (!response && flag) {
        return true;
      } else if (!response) return;

      if (saveType === 'save and proceed' && flag) {
        return;
      }

      saveType === 'save and proceed'
        ? history.push('related-person-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
    } else if (checkApplication) {
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      saveType === 'save and proceed'
        ? history.push('related-person-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
    }
  };

  const handleSubmit = async (values: Values) => {
    const { familyMappingType, ...modifiedValues } = values

    try {
      setLoading(true);
      await handleApplicant(modifiedValues, false);
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  async function fetchMinorData(panNumber: string, dob: any, values: any, guardianPan: string) {
    try {
      if (panNumber && !individualPanRegex.test(panNumber)) {
        throw 'Only individual PANs are allowed';
      } else if (panNumber === guardianPan) {
        throw `Minor ${getUniqueIdentityText(company)?.pan}  should not be same as Guardian ${getUniqueIdentityText(company)?.pan}`;
      } else if (dob && dob.toString() === 'Invalid Date') {
        throw 'Invalid Date';
      } else if (dob && futureAge(dob || '')) {
        throw 'Future date cannot be entered';
      } else if (dob && !isMinor(dob)) {
        throw 'Age should be less than 18';
      } else {
        setMinorDataFetched('fetching');
        const response = (await dispatch(FetchData({ panNumber, dob: dayjs(dob).format("YYYY-MM-DD") }))) as any;

        if (!response.success) {
          dispatch(showError(response?.message ?? "Data Not Found"))
          setMinorDataFetched('fetched');
          return
        }

        if (response.amlCheck) {
          if (response.data && Object.keys(response.data).length > 0) {
            setMinorDataFetched('fetched');
            setPreviousPan(panNumber);
            setPreviousDob(dob);
            setPersonalDetailsValues({
              ...personalDetailsValues,
              applicants: personalDetailsValues.applicants.map((applicant: any, index: number) => ({
                ...applicant,
                name: values.applicants[index].name,
                firstName: values.applicants[index].firstName,
                lastName: values.applicants[index].lastName,
                namePrefix: values.applicants[index].namePrefix,
                fatherOrSpouseName: values.applicants[index].fatherOrSpouseName,
                maritalStatus: values.applicants[index].maritalStatus,
                relationShipWithFirstApplicant:
                  values.applicants[index].relationShipWithFirstApplicant,
                gender: values.applicants[index].gender,
                occupationDetails: values.applicants[index].occupationDetails,
                occupationType: values.applicants[index].occupationType,
                status: values.applicants[index].status,
                minorPan: panNumber || '',
                minorDOB: dob || null,
                minorName: response.data.name || '',
                guardianRelationship: values.applicants[index].guardianRelationship || '',
                guardianRelationshipTypeOther:
                  values.applicants[index].guardianRelationshipTypeOther || '',
                // minorFirstName: response.data.minorFirstName || '',
                minorFirstName: response.data.firstName || '',
                // minorLastName: response.data.minorLastName || '',
                minorLastName: response.data.lastName || '',
                minorFatherName: response.data.fatherName || '',
                minorGender: response.data.gender || '',
                // minorMobile: (response.data.mobile).substring(2) || '',
                minorMobile: response.data.mobile || '',
                minorCountryNameAndCode: response.data.minorCountryNameAndCode || 'India: +91',
                minorCountryCode: response.data.minorCountryCode || '+91',
                minorEmail: response.data.email || '',
                minorNamePrefix: response.data.minorNamePrefix || 'Mr.',
              })),
              familyId: values?.familyId ?? "",
              familyName: values?.familyName ?? "",
              isHeadOfFamily: values?.isHeadOfFamily ?? false,
              isIndependent: values?.isIndependent ?? false,
              familyMappingType: values?.familyMappingType ?? FAMILY_MAPPING_TYPE.EXISTING
            });
            enqueueSnackbar('AML Verification Successful, Data Fetched', {
              variant: 'success',
              autoHideDuration: 3000,
            });
          } else {
            setMinorDataFetched('fetched');
            setPreviousPan(panNumber);
            setPreviousDob(dob);
            setPersonalDetailsValues({
              ...personalDetailsValues,
              applicants: personalDetailsValues.applicants.map((applicant: any, index: number) => ({
                ...applicant,
                name: values.applicants[index].name,
                namePrefix: values.applicants[index].namePrefix,
                fatherOrSpouseName: values.applicants[index].fatherOrSpouseName,
                maritalStatus: values.applicants[index].maritalStatus,
                relationShipWithFirstApplicant:
                  values.applicants[index].relationShipWithFirstApplicant,
                gender: values.applicants[index].gender,
                occupationDetails: values.applicants[index].occupationDetails,
                occupationType: values.applicants[index].occupationType,
                status: values.applicants[index].status,
                minorPan: panNumber || '',
                minorDOB: dob || null,
                minorName: '',
                minorFatherName: '',
                minorGender: '',
                minorMobile: '',
                minorCountryNameAndCode: 'India: +91',
                minorCountryCode: '+91',
                minorEmail: '',
                minorNamePrefix: 'Mr.',
                minorFirstName: '',
                minorLastName: '',
                firstName: values.applicants[index].firstName || '',
                lastName: values.applicants[index].lastName || '',
                guardianRelationship: values.applicants[index].guardianRelationship || '',
                guardianRelationshipTypeOther:
                  values.applicants[index].guardianRelationshipTypeOther || '',
              })),
              familyId: values?.familyId ?? "",
              familyName: values?.familyName ?? "",
              isHeadOfFamily: values?.isHeadOfFamily ?? false,
              isIndependent: values?.isIndependent ?? false,
              familyMappingType: values?.familyMappingType ?? FAMILY_MAPPING_TYPE.EXISTING
            });
            enqueueSnackbar('AML Verification Successful, Data Not Fetched', {
              variant: 'success',
              autoHideDuration: 3000,
            });
          }
        } else {
          setMinorDataFetched('failed');
          setPreviousPan(panNumber);
          setPreviousDob(dob);
          setPersonalDetailsValues({
            ...personalDetailsValues,
            applicants: personalDetailsValues.applicants.map((applicant: any, index: number) => ({
              ...applicant,
              name: values.applicants[index].name || '',
              namePrefix: values.applicants[index].namePrefix || '',
              fatherOrSpouseName: values.applicants[index].fatherOrSpouseName || '',
              maritalStatus: values.applicants[index].maritalStatus || '',
              relationShipWithFirstApplicant:
                values.applicants[index].relationShipWithFirstApplicant || '',
              gender: values.applicants[index].gender || '',
              occupationDetails: values.applicants[index].occupationDetails || '',
              occupationType: values.applicants[index].occupationType || '',
              status: values.applicants[index].status || '',
              minorPan: panNumber || '',
              minorDOB: dob || null,
              minorName: '',
              minorFirstName: '',
              minorLastName: '',
              firstName: values.applicants[index].firstName || '',
              lastName: values.applicants[index].lastName || '',
              guardianRelationship: '',
              guardianRelationshipTypeOther: '',
              minorFatherName: '',
              minorGender: '',
              minorMobile: '',
              minorCountryNameAndCode: 'India: +91',
              minorCountryCode: '+91',
              minorEmail: '',
              minorNamePrefix: 'Mr.',
            })),
            familyId: values?.familyId ?? "",
            familyName: values?.familyName ?? "",
            isHeadOfFamily: values?.isHeadOfFamily ?? false,
            isIndependent: values?.isIndependent ?? false,
            familyMappingType: values?.familyMappingType ?? FAMILY_MAPPING_TYPE.EXISTING
          });
          enqueueSnackbar('AML Verification Failed, Data Not Fetched', {
            variant: 'error',
            autoHideDuration: 3000,
          });
        }
      }
    } catch (e) {
      setMinorDataFetched('failed');
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  }

  const handleEditKycClick = async ({
    applicationId,
    applicantId,
    panNo
  }: {
    applicationId: string;
    applicantId: string;
    panNo: string;
  }) => {
    try {
      setEditKycLoading(true)

      const payload = {
        applicationId: Number(applicationId ?? ""),
        applicantId: Number(applicantId ?? ""),
        panNo
      }

      const response = await (dispatch(getDataForKycModification(payload)) as unknown as Promise<GetDataForKycModificationResponseBody>)

      if (response) {
        setKycData({
          ...(response?.kycDetails ?? {}),
          isNameChecked: false,
          isEmailChecked: false,
          isMobileChecked: false,
          isAddressChecked: false
        })

        setKycEditPopupOpen(true)
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setEditKycLoading(false)
    }
  }

  const handleKycEditPopupClose = () => {
    setKycEditPopupOpen(false)
    setSelectedApplicantId(null)
  }

  const handleKycEditSubmit = async () => {
    try {

      if (!formikRef.current) return

      setKycLinkLoading(true)

      const { values } = formikRef.current

      const currentApplicantData = (values?.applicants ?? []).find((obj) => Number(obj?.id ?? "") === selectedApplicantId)

      const payload = {
        panNo: currentApplicantData?.panNo ?? "",
        emailId: currentApplicantData?.email ?? "",
        investorName: currentApplicantData?.name ?? "",
        isNameChange: kycData?.isNameChecked ? "1" : "0",
        isEmailChange: kycData?.isEmailChecked ? "1" : "0",
        isMobileChange: kycData?.isMobileChecked ? "1" : "0",
        isAddressChange: kycData?.isAddressChecked ? "1" : "0",
        dob: currentApplicantData?.dateOfBirth ?? "",
        applicationId: Number(currentApplicantData?.applicationId ?? "")
      }

      const response = (await dispatch(MfuKycModification(payload)) as unknown as MfuKycModificationResponseBody);

      if (response) {
        setKycEditPopupOpen(false)
        setKycLinkData(response)
        setKycLinkPopupOpen(true)
      }

    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setKycLinkLoading(false)
    }
  }

  const handleCloseKycLinkPopup = () => {
    setKycLinkPopupOpen(false)
    setMandatoryKycModificationLinkPopupOpen(false)

    history.push('/applications')
  }

  const handleMandatoryKycModificationClick = async () => {
    try {
      if ((Object.keys(mismatchedApplicantData?.applicantData ?? {}) ?? []).length) {

        setMandatoryKycModificationLoading(true)

        const payload = {
          panNo: mismatchedApplicantData?.applicantData?.panNo ?? "",
          emailId: mismatchedApplicantData?.applicantData?.email ?? "",
          investorName: mismatchedApplicantData?.applicantData?.name ?? "",
          isNameChange: "1",
          isEmailChange: "1",
          isMobileChange: "1",
          isAddressChange: "1",
          dob: mismatchedApplicantData?.applicantData?.dateOfBirth ?? "",
          applicationId: Number(mismatchedApplicantData?.applicantData?.applicationId ?? "") as number
        }

        const response = (await dispatch(MfuKycModification(payload)) as unknown as MfuKycModificationResponseBody);

        if (response) {
          setMandatoryKycModificationRes(response)
          setMandatoryKycPopupOpen(false)
          setMismatchedApplicantData(null)
          setMandatoryKycModificationLinkPopupOpen(true)
        }
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setMandatoryKycModificationLoading(false)
    }
  }

  const handleApplicantDeleteClick = async () => {
    if (!formikRef?.current) return

    const { values } = formikRef.current

    const currentApplicantIndex = mismatchedApplicantData?.index

    const remainedApplicants = values.applicants.map((applicant, i) => {
      const noOfApplicants = values.applicants.length;
      if (i === currentApplicantIndex) {
        return {
          ...applicant,
          isActive: false,
        };
      }
      if (noOfApplicants === 3 && i === 2) {
        return {
          ...applicant,
          applicant_type: '2',
        };
      }
      return applicant;
    });
    const defaultPayload = {
      applicants: remainedApplicants.map((applicant) => {
        const { jointApplicantRelation, occupationDetails, occupationType, ...rest } =
          applicant;
        // console.log(applicant);
        return {
          ...rest,
          occupationDetails:
            occupationType !== 'Others' && occupationType !== null
              ? occupationType
              : occupationDetails
                ? occupationDetails
                : '',
          relationShipWithFirstApplicant: getRelation(jointApplicantRelation)
            ? jointApplicantRelation
            : applicant.relationShipWithFirstApplicant,
        };
      }),
      modeOfHolding:
        remainedApplicants.filter((applicant) => applicant.isActive).length === 1
          ? 'single'
          : values.modeOfHolding,
    };

    let currentStatus = application?.status

    if (
      !isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
      application?.status === 'sent_to_amc_approver'
    ) {
      currentStatus = 'draft'
    } else if (
      !application?.hasPOA &&
      AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
      application?.status !== 'draft' &&
      applyRoleBasedStatus(role)
    ) {
      currentStatus = 'sent_to_amc_approver'
    }

    try {
      if (application?.id) {
        setApplicantDeleteLoading(true)
        await dispatch(
          updateApplication({
            body: {
              ...application,
              ...defaultPayload,
              currentStep: 1,
              status: currentStatus
            },
            applicationId: application.id,
          })
        );

        setMismatchedApplicantData(null)
        setMandatoryKycPopupOpen(false)
      }
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    } finally {
      setApplicantDeleteLoading(false)
    }
  }

  return (
    <>
      {isFamilyListDataLoading && <LinearProgress />}
      {!isFamilyListDataLoading && (
        <>
          <Formik
            innerRef={formikRef}
            initialValues={personalDetailsValues}
            onSubmit={handleSubmit}
            validate={(values: Values) => {
              try {
                validateYupSchema(values, personalDetailsSchema(currencyCode, company, application), true, values);
              } catch (e) {
                return yupToFormErrors(e);
              }
            }}
            enableReinitialize={true}>
            {({
              handleSubmit,
              values,
              setValues,
              validateForm,
              setErrors,
              errors,
              setTouched,
              setFieldValue,
            }) => (
              <>
                <Grid
                  container
                  columnSpacing={3}
                  rowSpacing={0.5}
                  // rowSpacing={1}
                  // columnSpacing={5}
                  // sx={{
                  //   width: '100%',
                  //   ml: 0,
                  //   '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
                  // }}
                  component="form"
                  noValidate
                  onSubmit={handleSubmit}>
                  {values.applicants.map((applicant, index) => (
                    <React.Fragment key={index}>
                      <Grid item xs={12}>
                        <SubHeading
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: "10px 15px"
                          }}>
                          Personal Details of{' '}
                          {isOnboardingTypeMinor(application?.onboardingType || '')
                            ? 'Guardian'
                            : `${getApplicantName(index + 1)} Applicant`}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              columnGap: "15px"
                            }}
                          >
                            <LoadingButton
                              variant="outlined"
                              onClick={() => {
                                setSelectedApplicantId(Number(applicant?.id ?? ""))
                                handleEditKycClick({
                                  applicationId: applicant?.applicationId as string ?? "",
                                  applicantId: applicant?.id as string ?? "",
                                  panNo: applicant?.panNo ?? ""
                                })
                              }}
                              loading={isEditKycLoading}
                              loadingIndicator={
                                <CircularProgress
                                  size={18}
                                  sx={(theme: Theme) => ({ color: theme.palette.primary[500] })} />
                              }
                              sx={(theme: Theme) => ({
                                ...theme.typography.body_500,
                                fontWeight: 600,
                                color: theme.palette.primary[500],
                                padding: '5px',
                              })}
                            >
                              Edit KYC
                            </LoadingButton>
                            {index !== 0 && (
                              // <Box
                              //   sx={{ display: 'flex', alignItems: 'center' }}
                              //   onClick={() => setApplicantToDelete({ index })}>
                              //   <Typography
                              //     sx={{
                              //       color: 'rgba(196, 42, 51, 0.8)',
                              //       fontSize: 12,
                              //       ml: 'auto',
                              //       letterSpacing: '-0.2px',
                              //       cursor: 'pointer',
                              //     }}>
                              //     Remove Joint Holder{' '}
                              //   </Typography>
                              //   <IconButton sx={{ p: '2px' }}>
                              //     <CardMedia
                              //       component="img"
                              //       src="/images/delete-red.svg"
                              //       alt="Delete Icon"
                              //       sx={{ width: 'unset' }}
                              //     />
                              //   </IconButton>
                              // </Box>
                              <IconButton
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  backgroundColor: "primary.100",
                                  borderRadius: "50%",
                                  padding: "5px",
                                  marginRight: "7px",
                                  cursor: "pointer"
                                }}
                                onClick={() => setApplicantToDelete({ index })}
                                aria-label={`Remove ${getApplicantName(index + 1)} Applicant`}
                                >
                                <DeleteIconFilled />
                              </IconButton>
                            )}
                          </Box>
                        </SubHeading>
                      </Grid>
                      <PersonalDetails
                        index={index}
                        values={values}
                        applicationStatus={application?.status}
                        dataFetchedFromKRA={applicant.dataFetchedFromKRA || null}
                        setValues={setValues}
                        onboardingType={application?.onboardingType || ''}
                      />
                      {isOnboardingTypeMinor(application?.onboardingType || '') && (
                        <>
                          <Grid item xs={12}>
                            <SubHeading
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                              }}>
                              Personal Details of Minor Applicant
                            </SubHeading>
                          </Grid>
                          <MinorPersonalDetails
                            index={index}
                            values={values}
                            fetchMinorData={fetchMinorData}
                            minorDataFetched={minorDataFetched}
                            setMinorDataFetched={setMinorDataFetched}
                            setFieldValue={setFieldValue}
                            previousPan={previousPan}
                            previousDob={previousDob}
                            guardianPan={applicant.panNo}
                            isBSEEnabled={application?.isBSEEnabled}
                          />
                        </>
                      )}
                    </React.Fragment>
                  ))}
                  {!!values.applicants.length &&
                    values.applicants.length < 3 &&
                    (isDiyInvestorOnboarding ? true : ![USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)) &&
                    !isOnboardingTypeMinor(application?.onboardingType || '') && (
                      <Grid item xs={12}>
                        <LoadingButton
                          loading={checkJointHolder}
                          variant="outlined"
                          startIcon={<AddIcon sx={{ color: "primary.500", width: "16px", height: "16px" }} />}
                          disabled={USER_ROLES.AMCAPPROVER.includes(role)}
                          sx={(theme: Theme) => ({
                            color: theme.palette.primary[500],
                            // fontWeight: 500,
                            // fontSize: 14,
                            mt: 2.5,
                            backgroundColor: `${theme.palette.primary[500]}1A`,
                            border: `1px solid ${theme.palette.primary[500]}`,
                            borderRadius: "10px",
                            padding: "10px 15px",
                            ...theme.typography.body_500
                          })}
                          onClick={async () => {
                            const formErrors = await validateForm();
                            if (!Object.keys(formErrors).length) {
                              let res;
                              try {
                                setCheckJointHolder(true);
                                res = await handleApplicant(values, true);
                              } finally {
                                setCheckJointHolder(false);
                              }
                              if (res) return;
                              history.push(isDiyInvestorOnboarding ? '/add-diy-joint-holder/enter-pan-number' : '/onboarding/enter-pan-number', {
                                redirectTo:
                                  USER_ROLES.AMCAPPROVER === role
                                    ? '/investment-details/edit-application/personal-details'
                                    : `/${isDiyInvestorOnboarding ? "investor-onboarding-application" : "application"}/personal-details`,
                                application,
                                firstHolderName: getFirstHolderName(values.applicants),
                              });
                              return;
                            }
                            setTouched(setNestedObjectValues(formErrors, true));
                            setErrors(formErrors);
                          }}
                          loadingIndicator={
                            <CircularProgress size={18} sx={(theme: Theme) => ({ color: theme.palette.primary[500] })} />
                          }
                        >
                          Add Joint Holder
                        </LoadingButton>
                      </Grid>
                    )}
                  {values.applicants.length > 1 && (
                    <>
                      <Grid item xs={12} mt={2}>
                        <SubHeading>Redeem </SubHeading>
                      </Grid>
                      <Grid item xs={12}>
                        <MFCheckbox
                          checked={values.modeOfHolding === 'either or survivor'}
                          name="holding"
                          label="Either or Survivor"
                          onChange={({ target: { checked } }) => {
                            setFieldValue('modeOfHolding', checked ? 'either or survivor' : 'joint');
                            setOpen(checked ? false : true);
                          }}
                          disabled={isDiyInvestorOnboarding ? false : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
                          sx={{
                            color: values?.modeOfHolding === 'either or survivor' ? '#2057A6' : '#293139',
                          }}
                        />
                      </Grid>
                    </>
                  )}
                  {/* Family Tagging Start */}
                  <Grid item xs={12} my={3}>
                    <Divider sx={(theme: Theme) => ({ borderColor: theme.palette.grey[500] })} />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      id="family-mapping-label"
                      variant="h2"
                      sx={(theme: Theme) => ({
                        color: theme.palette.text.primary
                      })}
                    >
                      Family Mapping
                    </Typography>
                  </Grid>
                  <Grid item xs={12} mt={3.5}>
                    <UseRadioGroup
                      name="familyMappingType"
                      aria-labelledby="family-mapping-label"
                      items={familyMappingOptions}
                      onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                        setValues({
                          ...values,
                          familyId: "",
                          familyName: "",
                          isHeadOfFamily: value === FAMILY_MAPPING_TYPE.NEW,
                          isIndependent: false,
                          familyMappingType: value
                        })
                      }}
                    />
                  </Grid>
                  {values.familyMappingType === FAMILY_MAPPING_TYPE.EXISTING && (
                    <>
                      <Grid item xs={12} lg={6} mt={2}>
                        <SearchableSelect
                          name="familyId"
                          label="Existing Family Name*"
                          items={familyListData ?? []}
                          searchFieldPlaceholder={'Search Family'}
                          onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                            const selectedFamilyDetails = (familyListData ?? []).find(obj => obj?.value === value)

                            setValues({
                              ...values,
                              familyId: selectedFamilyDetails?.value ?? "",
                              familyName: selectedFamilyDetails?.key ?? ""
                            })
                          }}
                          value={values.familyId ?? ""}
                        />
                      </Grid>
                      <Grid item xs={12} lg={6} sx={{ alignContent: "center", mt: 2 }}>
                        <MFCheckbox
                          name="isIndependent"
                          label="Independent"
                          sx={(theme: Theme) => ({
                            color: `${theme.palette.text.primary}`,
                            "& :disabled": {
                              color: `${theme.palette.text.secondary}`,
                            }
                          })}
                        />
                      </Grid>
                    </>
                  )}
                  {values.familyMappingType === FAMILY_MAPPING_TYPE.NEW && (
                    <>
                      <Grid item xs={12} lg={6} mt={2}>
                        <MFTextField
                          name="familyName"
                          label="Family Name*"
                          placeholder="Enter Family Name"
                          value={values.familyName ?? ""}
                        />
                      </Grid>
                      <Grid item xs={12} lg={3} sx={{ alignContent: "center", mt: 2 }}>
                        <MFCheckbox
                          name="isHeadOfFamily"
                          label="Head of family"
                          sx={(theme: Theme) => ({
                            color: `${theme.palette.text.primary}`,
                            "& .MuiFormControlLabel-label.Mui-disabled": {
                              color: `${theme.palette.text.secondary}`,
                            }
                          })}
                          // onChange={({ target: { checked } }) => {
                          //   setValues({
                          //     ...values,
                          //     isHeadOfFamily: checked,
                          //     isIndependent: checked
                          //   })
                          // }}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} lg={3} sx={{ alignContent: "center", mt: 2 }}>
                        <MFCheckbox
                          name="isIndependent"
                          label="Independent"
                          sx={(theme: Theme) => ({
                            color: `${theme.palette.text.primary}`,
                            "& .MuiFormControlLabel-label.Mui-disabled": {
                              color: `${theme.palette.text.secondary}`,
                            }
                          })}
                          disabled={values.isHeadOfFamily}
                        />
                      </Grid>
                    </>
                  )}
                  {/* Famiily Tagging End */}
                  <Grid item xs={12} my={2} />
                  <ProceedSaveLater
                    saveLater={() => {
                      setValues({
                        ...values,
                        applicants: values.applicants.map((applicant) => ({
                          ...applicant,
                          relationShipWithFirstApplicant:
                            applicant.jointApplicantRelation === 'Others'
                              ? applicant.relationShipWithFirstApplicant
                              : applicant.jointApplicantRelation,
                        })),
                        saveType: 'save for later',
                      });
                    }}
                    saveAndProceed={() => {
                      setValues({
                        ...values,
                        applicants: values.applicants.map((applicant) => ({
                          ...applicant,
                          relationShipWithFirstApplicant:
                            applicant.jointApplicantRelation === 'Others'
                              ? applicant.relationShipWithFirstApplicant
                              : applicant.jointApplicantRelation,
                        })),
                        saveType: 'save and proceed',
                      });
                    }}
                    loader={loading}
                    clickedButton={values.saveType}
                    saveButtonText="Continue"
                    showEndIcon={false}
                  />
                </Grid>
                <Dialog
                  onClose={handleClose}
                  open={open}
                  maxWidth='sm'
                  fullWidth
                  sx={{
                    '& .MuiPaper-root': {
                      borderRadius: '15px',
                      backgroundColor: "background.paper",
                      rowGap: "25px",
                    },
                  }}
                // sx={{
                //   '.MuiPaper-root ': {
                //     p: 4,
                //     width: { xs: '70%', sm: '70%' },
                //   },
                // }}
                >
                  {/* <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <Box sx={{ mb: 2 }}>
            <CardMedia
              component="img"
              src="/images/warning-icon-red.svg"
              sx={{ width: 'unset', mx: 'auto' }}
            />
          </Box>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontSize: 20,
                fontWeight: 500,
                textAlign: 'center',
              },
            }}>
            <Typography sx={{ color: '#FD3A69', lineHeight: '35px' }}>
              Disabling “Either or Survivor” will cause issues later.
            </Typography>
            <Typography sx={{ color: 'primary.main', lineHeight: '35px' }}>
              Are you willing to disable?
            </Typography>
          </Box>
          <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
            <Button
              onClick={() => {
                setValues({
                  ...values,
                  modeOfHolding: 'joint',
                });
                handleClose();
              }}
              variant="outlined"
              sx={{
                fontSize: 14,
                color: 'primary.main',
                minWidth: 200,
              }}>
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setValues({
                  ...values,
                  modeOfHolding: 'either or survivor',
                });
                handleClose();
              }}
              sx={{
                fontSize: 14,
                minWidth: 200,
              }}>
              No
            </Button>
          </Grid> */}
                  <DialogContent sx={{ paddingTop: "25px" }}>
                    <Box sx={{ display: "flex", columnGap: "8px" }}>
                      <WarningIcon />
                      <Typography variant='h2' color="text.primary" mb="10px">Disabling “Either or Survivor”</Typography>
                    </Box>
                    <Typography
                      variant='subtitle_400'
                      color="text.secondary"
                      sx={{
                        lineHeight: "20px"
                      }}
                    >
                      Disabling “Either or Survivor” will cause issues later. Are you willing to disable?
                    </Typography>
                  </DialogContent>
                  <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setValues({
                          ...values,
                          modeOfHolding: 'either or survivor',
                        });
                        handleClose();
                      }}
                      sx={(theme: Theme) => ({
                        color: theme.palette.text.secondary,
                        flex: 1,
                        border: `0.5px solid ${theme.palette.text.secondary}`,
                        padding: "10px",
                        "&:hover, &.Mui-focusVisible": {
                          borderColor: theme.palette.text.secondary,
                          backgroundColor: theme.palette.background.default
                        }
                      })}
                    >
                      No
                    </Button>
                    <Button
                      variant="contained"
                      sx={(theme: Theme) => ({
                        flex: 1,
                        color: theme.palette.textDark.primary,
                        padding: "10px"
                      })}
                      onClick={() => {
                        setValues({
                          ...values,
                          modeOfHolding: 'joint',
                        });
                        handleClose();
                      }}
                    >
                      Yes
                    </Button>
                  </DialogActions>
                </Dialog>
                <ConfirmationDialog
                  // message={`Are you sure you want to delete applicant ?`}
                  showIcon
                  message="Deleting Joint Holder"
                  subMessage="Are you sure you want to delete the Joint Holder details? "
                  open={applicantToDelete !== null}
                  setOpen={() => setApplicantToDelete(null)}
                  onSave={async () => {
                    const remainedApplicants = values.applicants.map((applicant, i) => {
                      const noOfApplicants = values.applicants.length;
                      if (i === applicantToDelete?.index) {
                        return {
                          ...applicant,
                          isActive: false,
                        };
                      }
                      if (noOfApplicants === 3 && i === 2) {
                        return {
                          ...applicant,
                          applicant_type: '2',
                        };
                      }
                      return applicant;
                    });
                    const defaultPayload = {
                      applicants: remainedApplicants.map((applicant) => {
                        const { jointApplicantRelation, occupationDetails, occupationType, ...rest } =
                          applicant;
                        // console.log(applicant);
                        return {
                          ...rest,
                          occupationDetails:
                            occupationType !== 'Others' && occupationType !== null
                              ? occupationType
                              : occupationDetails
                                ? occupationDetails
                                : '',
                          relationShipWithFirstApplicant: getRelation(jointApplicantRelation)
                            ? jointApplicantRelation
                            : applicant.relationShipWithFirstApplicant,
                        };
                      }),
                      modeOfHolding:
                        remainedApplicants.filter((applicant) => applicant.isActive).length === 1
                          ? 'single'
                          : values.modeOfHolding,
                    };

                    let currentStatus = application?.status

                    if (
                      !isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
                      application?.status === 'sent_to_amc_approver'
                    ) {
                      currentStatus = 'draft'
                    } else if (
                      !application?.hasPOA &&
                      AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                      application?.status !== 'draft' &&
                      applyRoleBasedStatus(role)
                    ) {
                      currentStatus = 'sent_to_amc_approver'
                    }

                    try {
                      if (application?.id) {
                        setApplicantToDelete(null);
                        await dispatch(
                          updateApplication({
                            body: {
                              ...application,
                              ...defaultPayload,
                              currentStep: 1,
                              status: currentStatus
                            },
                            applicationId: application.id,
                          })
                        );
                      }
                    } catch (e) {
                      typeof e === 'string' && dispatch(showError(e));
                      console.error((e as Error).message);
                    }
                  }}
                  onCancel={() => setApplicantToDelete(null)}
                />
              </>
            )
            }
          </Formik>
          <KycEditPopup
            open={isKycEditPopupOpen}
            kycData={kycData}
            setKycData={setKycData}
            onClose={handleKycEditPopupClose}
            onSubmit={handleKycEditSubmit}
            isSubmitBtnLoading={kycLinkLoading}
          />
          <KycInfoPopup
            open={kycLinkPopupOpen}
            title={kycLinkData?.message ?? ""}
            subtitle={kycLinkData?.kycOnboardingURL ?? ""}
            copyText={kycLinkData?.kycOnboardingURL ?? ""}
            submitButtonLabel="Okay"
            onSubmitBtnClick={handleCloseKycLinkPopup}
          />
          <KycInfoPopup
            open={mandatoryKycPopupOpen}
            title="The data does not match the KYC records. Do you want to proceed with KYC modification?"
            subtitle={`KRA Mobile: ${mismatchedApplicantData?.applicantData?.kraMobileNumber ?? "-"}\nKRA Email: ${mismatchedApplicantData?.applicantData?.kraEmailId ?? "-"}`}
            submitButtonLabel="Yes"
            onSubmitBtnClick={handleMandatoryKycModificationClick}
            showCloseButton
            closeButtonLabel="Delete the applicant"
            onCloseBtnClick={handleApplicantDeleteClick}
            // titleSpacing={6}
            isSubmitBtnLoading={isMandatoryKycModificationLoading}
            isCloseBtnLoading={isApplicantDeleteLoading}
          />
          <KycInfoPopup
            open={mandatoryKycModificationLinkPopupOpen}
            title={mandatoryKycModificationRes?.message ?? ""}
            subtitle={mandatoryKycModificationRes?.kycOnboardingURL ?? ""}
            copyText={mandatoryKycModificationRes?.kycOnboardingURL ?? ""}
            submitButtonLabel="Okay"
            onSubmitBtnClick={handleCloseKycLinkPopup}
          />
        </>
      )}
    </>
  );
}
